// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hall rail — club-desk navigation. Active page is a sideline, not a blue slab. */
.hall-rail.ps-sidebar-root {
  --hr-pine: var(--brand-primary, #0877bc);
  --hr-tape: color-mix(in srgb, #fff 86%, var(--brand-primary, #0877bc));
  --hr-ease: cubic-bezier(0.22, 1, 0.36, 1);
  position: relative;
  height: 100%;
  border-right: 1px solid var(--border-color, rgba(15, 23, 42, 0.1));
  background: var(--surface-color, #fff) !important;
}

.hall-rail .ps-sidebar-container {
  background: var(--surface-color, #fff) !important;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-left: 4px;
}

.hall-rail::before {
  content: "";
  position: absolute;
  z-index: 2;
  inset: 0 auto 0 0;
  width: 4px;
  pointer-events: none;
  background:
    linear-gradient(
      180deg,
      var(--hr-tape) 0 6px,
      transparent 6px 12px,
      var(--hr-tape) 12px 18px,
      transparent 18px
    ),
    var(--hr-pine);
  background-size: 4px 24px, auto;
}

.hall-rail__club {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  width: calc(100% - 1.1rem);
  margin: 0.45rem 0.55rem 0.15rem;
  padding: 0.4rem 0.55rem;
  border: 0;
  border-radius: 12px;
  background: color-mix(in srgb, var(--hr-pine) 8%, var(--surface-color, #fff));
  color: inherit;
  text-align: left;
  cursor: pointer;
  font: inherit;
}

.hall-rail__club:hover {
  background: color-mix(in srgb, var(--hr-pine) 14%, var(--surface-color, #fff));
}

.hall-rail__club.is-static {
  cursor: default;
}

.hall-rail__club img {
  width: auto;
  max-width: 40px;
  max-height: 44px;
  height: auto;
  object-fit: contain;
  flex-shrink: 0;
}

.hall-rail__club-copy {
  min-width: 0;
}

.hall-rail__club-name {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.86rem;
  font-weight: 650;
  letter-spacing: -0.01em;
  color: var(--text-color);
}

.hall-rail__club-hint {
  display: block;
  margin-top: 0.12rem;
  font-size: 0.68rem;
  color: var(--text-secondary, #64748b);
}

.hall-rail__nav {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 0 0.75rem;
}

.hall-rail__kicker {
  margin: 0.45rem 1.05rem 0.05rem;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--text-secondary, #64748b);
}

.hall-rail .ps-menu-root > .hall-rail__kicker {
  display: block;
  list-style: none;
}

.hall-rail .ps-menu-root {
  background: transparent;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.hall-rail .ps-menu-button {
  margin: 0 0.45rem;
  height: 36px !important;
  padding-left: 12px !important;
  padding-right: 10px !important;
  border-radius: 10px;
  color: var(--text-color) !important;
  font-size: 0.9rem !important;
  font-weight: 500;
  transition: background 0.16s var(--hr-ease), color 0.16s var(--hr-ease);
}

.hall-rail .ps-menu-icon {
  width: 22px;
  min-width: 22px;
  margin-right: 10px;
  color: var(--text-secondary, #64748b);
}

.hall-rail .ps-menu-icon svg {
  display: block;
}

.admin-theme-root .hall-rail .ps-menu-button:hover {
  background: color-mix(in srgb, var(--hr-pine) 9%, transparent) !important;
  color: var(--text-color) !important;
}

.admin-theme-root .hall-rail .ps-menu-button:hover .ps-menu-icon,
.admin-theme-root .hall-rail .ps-menu-button:hover .ps-menu-label,
.admin-theme-root .hall-rail .ps-menu-button:hover span,
.admin-theme-root .hall-rail .ps-menu-button:hover svg {
  color: var(--text-color) !important;
}

.admin-theme-root .hall-rail .ps-menuitem-root.active > .ps-menu-button,
.admin-theme-root .hall-rail .ps-menu-button.active,
.admin-theme-root .hall-rail li.active > .ps-menu-button,
.light-mode .admin-theme-root .hall-rail .ps-menuitem-root.active > .ps-menu-button,
.dark-mode .admin-theme-root .hall-rail .ps-menuitem-root.active > .ps-menu-button {
  background: color-mix(in srgb, var(--hr-pine) 12%, var(--surface-color, #fff)) !important;
  border-left: 3px solid var(--brand-primary, #0877bc) !important;
  color: var(--text-color) !important;
  box-shadow: none;
}

.admin-theme-root .hall-rail .ps-menuitem-root.active > .ps-menu-button .ps-menu-icon,
.admin-theme-root .hall-rail .ps-menuitem-root.active > .ps-menu-button .ps-menu-label,
.admin-theme-root .hall-rail .ps-menuitem-root.active > .ps-menu-button span,
.admin-theme-root .hall-rail .ps-menuitem-root.active > .ps-menu-button svg,
.admin-theme-root .hall-rail li.active > .ps-menu-button span,
.admin-theme-root .hall-rail li.active > .ps-menu-button svg {
  color: var(--text-color) !important;
}

.hall-rail .ps-submenu-expand-icon {
  color: var(--text-secondary, #64748b);
}

.hall-rail .ps-menu-button:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: -2px;
}

.hall-rail .ps-submenu-content .ps-menu-button {
  padding-left: 22px !important;
}

.hall-rail__toggle {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 10020;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid var(--border-color, rgba(15, 23, 42, 0.12));
  border-radius: 12px;
  background: var(--surface-color, #fff);
  color: var(--text-color);
  box-shadow: 0 4px 14px color-mix(in srgb, var(--text-color) 10%, transparent);
  cursor: pointer;
}

.hall-rail__toggle.is-open {
  background: var(--hr-pine);
  border-color: var(--hr-pine);
  color: #f4f7f5;
}

.hall-rail__toggle:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 3px;
}

@media (prefers-reduced-motion: no-preference) {
  .hall-rail.ps-sidebar-root {
    transition: transform 0.28s var(--hr-ease);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminLayout/SideBar.css"],"names":[],"mappings":"AAAA,kFAAkF;AAClF;EACE,wCAAwC;EACxC,sEAAsE;EACtE,yCAAyC;EACzC,kBAAkB;EAClB,YAAY;EACZ,kEAAkE;EAClE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,UAAU;EACV,oBAAoB;EACpB;;;;;;;;kBAQgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,6EAA6E;EAC7E,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,uEAAuE;AACzE;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yEAAyE;EACzE,mCAAmC;AACrC;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;;;;;EAKE,yFAAyF;EACzF,+DAA+D;EAC/D,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;;;;;;EAME,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,sCAAsC;EACtC,wBAAwB;EACxB,6EAA6E;EAC7E,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE;IACE,0CAA0C;EAC5C;AACF","sourcesContent":["/* Hall rail — club-desk navigation. Active page is a sideline, not a blue slab. */\n.hall-rail.ps-sidebar-root {\n  --hr-pine: var(--brand-primary, #0877bc);\n  --hr-tape: color-mix(in srgb, #fff 86%, var(--brand-primary, #0877bc));\n  --hr-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  position: relative;\n  height: 100%;\n  border-right: 1px solid var(--border-color, rgba(15, 23, 42, 0.1));\n  background: var(--surface-color, #fff) !important;\n}\n\n.hall-rail .ps-sidebar-container {\n  background: var(--surface-color, #fff) !important;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding-left: 4px;\n}\n\n.hall-rail::before {\n  content: \"\";\n  position: absolute;\n  z-index: 2;\n  inset: 0 auto 0 0;\n  width: 4px;\n  pointer-events: none;\n  background:\n    linear-gradient(\n      180deg,\n      var(--hr-tape) 0 6px,\n      transparent 6px 12px,\n      var(--hr-tape) 12px 18px,\n      transparent 18px\n    ),\n    var(--hr-pine);\n  background-size: 4px 24px, auto;\n}\n\n.hall-rail__club {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  width: calc(100% - 1.1rem);\n  margin: 0.45rem 0.55rem 0.15rem;\n  padding: 0.4rem 0.55rem;\n  border: 0;\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--hr-pine) 8%, var(--surface-color, #fff));\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n  font: inherit;\n}\n\n.hall-rail__club:hover {\n  background: color-mix(in srgb, var(--hr-pine) 14%, var(--surface-color, #fff));\n}\n\n.hall-rail__club.is-static {\n  cursor: default;\n}\n\n.hall-rail__club img {\n  width: auto;\n  max-width: 40px;\n  max-height: 44px;\n  height: auto;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.hall-rail__club-copy {\n  min-width: 0;\n}\n\n.hall-rail__club-name {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.86rem;\n  font-weight: 650;\n  letter-spacing: -0.01em;\n  color: var(--text-color);\n}\n\n.hall-rail__club-hint {\n  display: block;\n  margin-top: 0.12rem;\n  font-size: 0.68rem;\n  color: var(--text-secondary, #64748b);\n}\n\n.hall-rail__nav {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0 0 0.75rem;\n}\n\n.hall-rail__kicker {\n  margin: 0.45rem 1.05rem 0.05rem;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #64748b);\n}\n\n.hall-rail .ps-menu-root > .hall-rail__kicker {\n  display: block;\n  list-style: none;\n}\n\n.hall-rail .ps-menu-root {\n  background: transparent;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.hall-rail .ps-menu-button {\n  margin: 0 0.45rem;\n  height: 36px !important;\n  padding-left: 12px !important;\n  padding-right: 10px !important;\n  border-radius: 10px;\n  color: var(--text-color) !important;\n  font-size: 0.9rem !important;\n  font-weight: 500;\n  transition: background 0.16s var(--hr-ease), color 0.16s var(--hr-ease);\n}\n\n.hall-rail .ps-menu-icon {\n  width: 22px;\n  min-width: 22px;\n  margin-right: 10px;\n  color: var(--text-secondary, #64748b);\n}\n\n.hall-rail .ps-menu-icon svg {\n  display: block;\n}\n\n.admin-theme-root .hall-rail .ps-menu-button:hover {\n  background: color-mix(in srgb, var(--hr-pine) 9%, transparent) !important;\n  color: var(--text-color) !important;\n}\n\n.admin-theme-root .hall-rail .ps-menu-button:hover .ps-menu-icon,\n.admin-theme-root .hall-rail .ps-menu-button:hover .ps-menu-label,\n.admin-theme-root .hall-rail .ps-menu-button:hover span,\n.admin-theme-root .hall-rail .ps-menu-button:hover svg {\n  color: var(--text-color) !important;\n}\n\n.admin-theme-root .hall-rail .ps-menuitem-root.active > .ps-menu-button,\n.admin-theme-root .hall-rail .ps-menu-button.active,\n.admin-theme-root .hall-rail li.active > .ps-menu-button,\n.light-mode .admin-theme-root .hall-rail .ps-menuitem-root.active > .ps-menu-button,\n.dark-mode .admin-theme-root .hall-rail .ps-menuitem-root.active > .ps-menu-button {\n  background: color-mix(in srgb, var(--hr-pine) 12%, var(--surface-color, #fff)) !important;\n  border-left: 3px solid var(--brand-primary, #0877bc) !important;\n  color: var(--text-color) !important;\n  box-shadow: none;\n}\n\n.admin-theme-root .hall-rail .ps-menuitem-root.active > .ps-menu-button .ps-menu-icon,\n.admin-theme-root .hall-rail .ps-menuitem-root.active > .ps-menu-button .ps-menu-label,\n.admin-theme-root .hall-rail .ps-menuitem-root.active > .ps-menu-button span,\n.admin-theme-root .hall-rail .ps-menuitem-root.active > .ps-menu-button svg,\n.admin-theme-root .hall-rail li.active > .ps-menu-button span,\n.admin-theme-root .hall-rail li.active > .ps-menu-button svg {\n  color: var(--text-color) !important;\n}\n\n.hall-rail .ps-submenu-expand-icon {\n  color: var(--text-secondary, #64748b);\n}\n\n.hall-rail .ps-menu-button:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: -2px;\n}\n\n.hall-rail .ps-submenu-content .ps-menu-button {\n  padding-left: 22px !important;\n}\n\n.hall-rail__toggle {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  z-index: 10020;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: 1px solid var(--border-color, rgba(15, 23, 42, 0.12));\n  border-radius: 12px;\n  background: var(--surface-color, #fff);\n  color: var(--text-color);\n  box-shadow: 0 4px 14px color-mix(in srgb, var(--text-color) 10%, transparent);\n  cursor: pointer;\n}\n\n.hall-rail__toggle.is-open {\n  background: var(--hr-pine);\n  border-color: var(--hr-pine);\n  color: #f4f7f5;\n}\n\n.hall-rail__toggle:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 3px;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .hall-rail.ps-sidebar-root {\n    transition: transform 0.28s var(--hr-ease);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
